<template>
  <div>
    <div v-if="limsds_userDetails.userEmail != null && limsds_userDetails.userEmail != ''">
      <v-form>
        <v-row dense>
          <v-col sm="1" class="InstructionsBold"> Step 1 : </v-col>
          <v-col sm="7" class="Instructions"
            >Choose a sample login method.
          </v-col>
          <v-col align="Right" sm="4">
            <v-menu open-on-hover top offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="orange" small v-bind="attrs" v-on="on"
                  >mdi-help</v-icon
                >
              </template>
              <v-list>
                <v-list-item
                  ><a
                    :href="NewsLetter"
                    title="Newsletter Index"
                    target="limsds_help"
                    >Newsletter Index</a
                  ></v-list-item
                >
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-radio-group
              row
              v-model="loginMethod"
              dense
              hide-details
              @change="checkRadio"
            >
              <v-radio label="Ad-Hoc" value="A" dense></v-radio>
              <v-radio label="Sample Point" value="S" dense></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="1" class="InstructionsBold">Step 2 : </v-col>
          <v-col sm="7" class="Instructions"
            >Enter the Sample Information.
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="4">
            <v-select
              solo
              hide-details
              dense
              :disabled="siteDisable"
              label="Select Site"
              v-model="selectedSite"
              @input="FillUnitDropDown"
              :items="defaultValues.SiteList"
              item-text="site"
              item-value="site"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="4">
            <v-select
              :disabled="unitDisable"
              label="Select Unit"
              v-model="selectedUnit"
              @input="FillAreaDropDown"
              :items="defaultValues.UnitList"
              solo
              hide-details
              dense
              item-text="name"
              item-value="name"
            ></v-select>
          </v-col>
          <v-col sm="4">
            <v-select
              :disabled="areaDisable"
              solo
              hide-details
              dense
              label="Select Area"
              v-model="selectedArea"
              @input="FillModeDropDown"
              :items="areaList"
              item-text="areaName"
              item-value="areaName"
            ></v-select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="4">
            <v-select
              @input="FillSamplePointDropDown"
              :disabled="modeDisable"
              solo
              hide-details
              dense
              label="Select Mode"
              v-model="selectedMode"
              :items="modeList"
              item-text="modeName"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col sm="4" :hidden="hideControl">
            <v-autocomplete
              :disabled="spDisable"
              v-model="selectedSP"
              :items="spList"
              item-text="spName"
              item-value="id"
              dense
              solo
              hide-details
              filled
              label="Sample Point"
              @change="FillTestChecklist"
            ></v-autocomplete>
          </v-col>

          <v-col justify="left" sm="1" :hidden="hideControl">
            <v-dialog max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-icon color="blue " large> mdi-magnify </v-icon>
                </div>
              </template>
              <v-data-table
                dense
                :hide-default-footer="true"
                disable-pagination
                :headers="spHeaders"
                :items="spList"
                item-key="id"
                class="elevation-1 primary"
              >
              </v-data-table>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="4">
            <v-text-field
              :disabled="schDateDisable"
              v-model="scheduledDate"
              dense
              solo
              hide-details
              type="date"
              label="Scheduled Date"
            ></v-text-field>
          </v-col>
          <v-col sm="4">
            <v-text-field
              :disabled="schTimeDisable"
              v-model="scheduledTime"
              dense
              solo
              hide-details
              type="time"
              label="Scheduled Time"
            ></v-text-field>
          </v-col>
          <v-col sm="4"> </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="4">
            <v-text-field
              :disabled="colDateDisable"
              v-model="collectedDate"
              dense
              solo
              hide-details
              type="Date"
              label="Collected Date"
            ></v-text-field>
          </v-col>
          <v-col sm="4">
            <v-text-field
              :disabled="colTimeDisable"
              v-model="collectedTime"
              dense
              solo
              hide-details
              type="time"
              label="Collected Time"
            ></v-text-field>
          </v-col>
          <v-col sm="4"> </v-col>
        </v-row>
        <v-row dense :hidden="hideControl">
          <v-col sm="4">
            <v-text-field
              :disabled="lotDisable"
              v-model="lot"
              dense
              solo
              hide-details
              label="Lot#"
            ></v-text-field>
          </v-col>
          <v-col sm="4">
            <v-text-field
              :disabled="batchDisable"
              v-model="batch"
              dense
              solo
              hide-details
              label="Batch#"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col sm="8">
            <v-text-field
              :disabled="dsecDisable"
              v-model="description"
              dense
              solo
              hide-details
              label="Description"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="8">
            <v-textarea
              :disabled="noteDisable"
              v-model="notes"
              dense
              label="Note"
              auto-grow
              solo
              hide-details
              rows="2"
              row-height="15"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row dense :hidden="hideControl">
          <v-col sm="12" md="4" lg="3">
            <v-checkbox
              v-for="test in testList"
              :key="`option-${test.id}`"
              hide-details
              dense
              :label="test.testName"
              v-model="selectedTest"
              :value="test.id"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="2">
            <v-btn
              :disabled="btnDisable"
              rounded
              color="primary"
              dense
              solo
              hide-details
              dark
              @click="saveSample"
              >Login Samples
            </v-btn>
          </v-col>
          <v-col sm="2"></v-col>
        </v-row>
      </v-form>
    </div>
    <div v-if="limsds_userDetails.userEmail == null">
      <h3>INVALID USER !!!</h3>
      <h4>Current user is not exist in system database !!!</h4>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
import moment from "moment";
import notificationMixin from "@/_mixins/notification-mixin";
export default {
  name: "SubmitSampleSapphire",
  mixins: [uiView, appMixin, notificationMixin],
  components: {},

  created() {
    this.NewsLetter = this.settings.NewsLetter;
    if (this.limsds_userDetails.userEmail != null) {
      this.list = this.limsds_userPreference;
      if (this.list.site1 != "" || this.list.site1 != null) {
        this.siteDisable = false;
        this.fillSite();
        this.selectedSite = this.list.site1;
        this.selectedSite = "CXO";
        this.FillUnitDropDown(this.selectedSite);
      }
    }
  },
  mounted() {},
  computed: {
    currentDate: function () {
      return moment().format("YYYY-MM-DD hh:mm");
    },
  },
  data() {
    return {
      selectedTest: [],
      saveResult: null,
      batch: null,
      lot: null,
      description: null,
      notes: null,
      scheduledDate: moment().format("YYYY-MM-DD"),
      scheduledTime: moment().format("hh:mm:ss"),
      collectedDate: moment().format("YYYY-MM-DD"),
      collectedTime: moment().format("hh:mm:ss"),
      spHeaders: [
        { text: "Sample Point", value: "id" },
        { text: "Sample Point Descriptions", value: "spName" },
      ],
      hideControl: false,
      areaList: [],
      modeList: [],
      spList: [],
      testList: [],
      selectedSite: null,
      selectedUnit: null,
      selectedArea: null,
      selectedMode: null,
      selectedSP: null,
      btnDisable: true,
      siteDisable: true,
      unitDisable: true,
      areaDisable: true,
      modeDisable: true,
      spDisable: true,
      schDateDisable: true,
      schTimeDisable: true,
      colDateDisable: true,
      colTimeDisable: true,
      lotDisable: true,
      batchDisable: true,
      dsecDisable: true,
      noteDisable: true,
      loginMethod: "S",
      DateFormat: null,
      ChildComponent: false,
      ParentComponent: true,
      singleSelect: false,
      isLoading: false,
      list: {},
      SampleListResult: [],
      SelectedSampleListResult: [],
      defaultValues: {
        Note: "",
        SiteList: undefined,
        UnitList: undefined,
      },
    };
  },

  methods: {
    fillSite() {
      let that = this;
      const SiteLink = that.settings.WASite + "UserID=" + this.limsds_userDetails.userEmail;
      axios.get(SiteLink).then((response) => {
        that.defaultValues.SiteList = response.data.enumSiteLists;
      });
    },
    saveSample() {
      let that = this;
      debugger
      const saveLink =
        "https://localhost:44332/api/LoginSampleSapphire?site=" +
        this.selectedSite +
        "&sample_pointid=" +
        this.selectedSP +
        "&userid=" +
        this.limsds_userDetails.userEmail +
        "&paramlists=" +
        this.selectedTest +
        "&scheduled_datetime=" +
        this.scheduledDate +
        "&collected_datetime=" +
        this.collectedDate +
        "&description=" +
        this.description +
        "&notes=" +
        this.notes +
        "&batchid=" +
        this.batch +
        "&lot=" +
        this.lot;
      axios.get(saveLink).then((response) => {
        if (that.loginMethod=="S")
        {
              that.saveResult = JSON.parse(
          response.data.value
        ).propertylist.property[24]["#cdata-section"];
        }else{
          that.saveResult = JSON.parse(
          response.data.value
        ).propertylist.property[23]["#cdata-section"];

        }
        console.log(that.saveResult.length);
        if (that.saveResult.length > 0) {
          that.addNotification({
            message: "Sample Created Successfully: Sappire Sample ID " + that.saveResult,
            type: "info",
            delay: 100000,
            top: true,
            center: true,
          });
          that.selectedSP=null;
          that.testList=[];
          that.lot="";
          that.description="";
          that.notes="";
          that.batch="";
          that.selectedTest=[];
        }else{
          that.addNotification({
            message: "Sample Not Created : Some issue occuring..",
            type: "error",
            delay: 100000,
            top: true,
            center: true,
          });
        }

      });
    },
    checkRadio(value) {
      if (value == "A") {
        this.hideControl = true;
        this.selectedSP="";
        this.batch="";
        this.lot="";
        this.selectedTest="";
      } else {
        this.hideControl = false;
      }
    },
    FillUnitDropDown(value) {
      this.unitDisable = false;
      const UnitLink =
        "https://localhost:44332/api/EnumServiceURLandSubmitterUnitsSECURE?userid=" +
        this.limsds_userDetails.userEmail +
        "&site=" +
        this.selectedSite;
      axios.get(UnitLink).then((response) => {
        this.defaultValues.UnitList = JSON.parse(response.data.value).units;
      });
    },
    FillAreaDropDown(value) {
      let that = this;
      this.areaDisable = false;
      const AreaLink =
        "https://localhost:44332/api/AreasForProcessUnit?site=" +
        this.selectedSite +
        "&unit=" +
        this.selectedUnit;

      axios.get(AreaLink).then((response) => {
        let tempArea = JSON.parse(response.data.value).dataset.rows.row;
        that.areaList = tempArea.map((x) => ({
          id: x.col["@id"],
          areaName: x.col["#cdata-section"],
        }));
      });
    },
    FillModeDropDown(value) {
      let that = this;
      this.modeDisable = false;
      if (this.loginMethod == "A") {
        this.modeList = [{ modeId: "000", modeName: "000" }];
        this.selectedMode = "000";
        this.modeDisable = false;
        this.schDateDisable = false;
        this.schTimeDisable = false;
        this.colDateDisable = false;
        this.colTimeDisable = false;
        this.dsecDisable = false;
        this.noteDisable = false;
        this.btnDisable = false;
      } else {
        const modeLink =
          "https://localhost:44332/api/ModesForProcessArea?site=" +
          this.selectedSite +
          "&unit=" +
          this.selectedUnit +
          "&area=" +
          this.selectedArea;

        axios.get(modeLink).then((response) => {
          let item = JSON.parse(response.data.value).dataset.rows.row.col;
          for (let i = 1; i < item.length; i++) {
            var id = JSON.parse(response.data.value).dataset.rows.row.col[0][
              "#cdata-section"
            ];
            var modeName =
              JSON.parse(response.data.value).dataset.rows.row.col[0][
                "#cdata-section"
              ] +
              " | " +
              JSON.parse(response.data.value).dataset.rows.row.col[1][
                "#cdata-section"
              ];
            that.modeList.push({
              id: id,
              modeName: modeName,
            });
          }
        });
      }
    },
    FillSamplePointDropDown() {
      let that = this;
      this.spDisable = false;
      const spLink =
        "https://localhost:44332/api/SamplePointList?site=" +
        this.selectedSite +
        "&unit=" +
        this.selectedUnit +
        "&area=" +
        this.selectedArea +
        "&mode=" +
        this.selectedMode;
      axios.get(spLink).then((response) => {
        let item = JSON.parse(response.data.value).dataset.rows.row;
        for (let i = 0; i < item.length; i++) {
          var id = JSON.parse(response.data.value).dataset.rows.row[i].col[0][
            "#cdata-section"
          ];
          var spName =
           JSON.parse(response.data.value).dataset.rows.row[i].col[1][
              "#cdata-section"
            ] +
            " | " +
            JSON.parse(response.data.value).dataset.rows.row[i].col[0][
              "#cdata-section"
            ];
           
          that.spList.push({
            id: id,
            spName: spName,
          });
        }
      });
    },
    FillTestChecklist() {
      let that = this;
      this.schDateDisable = false;
      this.schTimeDisable = false;
      this.colDateDisable = false;
      this.colTimeDisable = false;
      this.noteDisable = false;
      this.lotDisable = false;
      this.batchDisable = false;
      this.btnDisable = false;
      var desc = this.spList.find(
              (x) => x.id == this.selectedSP
            )?.spName;
      var descArray= desc.split("|");
      this.description = descArray[0];
      const testLink =
        "https://localhost:44332/api/TestsForSamplePoint?site=" +
        this.selectedSite +
        "&sample_pointid=" +
        this.selectedSP;
      axios.get(testLink).then((response) => {
        let item = JSON.parse(response.data.value).dataset.rows.row;
        for (let i = 0; i < item.length; i++) {
          var id = JSON.parse(response.data.value).dataset.rows.row[i].col[0][
            "#cdata-section"
          ];
          var testName =
            JSON.parse(response.data.value).dataset.rows.row[i].col[0][
              "#cdata-section"
            ] +
            " ( " +
            JSON.parse(response.data.value).dataset.rows.row[i].col[1][
              "#cdata-section"
            ]; + " ) "
          that.testList.push({
            id: id,
            testName: testName,
          });
          that.selectedTest.push(id);
        }
      });
    },
  },
};
</script>
<style  scoped>
.v-text-field.v-text-field--solo.v-input--dense > .v-input__control, .v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
    min-height: 24px;
}
.v-text-field--filled.v-input--dense.v-text-field--single-line .v-label, .v-text-field--full-width.v-input--dense.v-text-field--single-line .v-label {
    top: 3px;
}
.v-text-field__slot {
    padding: 0px !important;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 26px;
  min-width: 64px;
  padding: 0 10px;
}
.Lable {
  color: black;
}
.TableClass {
  background-color: antiquewhite;
  padding-block: 5;
  text-align: left;
  font-family: verdana;
  /* font-size: 300%; */
  border: 2px solid powderblue;
  margin: 50px;
  border: solid;
}
.DropDownClass {
  max-width: 50%;
}
.topics tr {
  line-height: 10px;
}
</style>